import axios from "axios";

export const getAccessToken = async () => {
  try {
    
    const response = await axios.post("https://career.medha.org.in/api/token", {});    
    const accessToken = response.data.access_token;
    localStorage.setItem("access_token", accessToken);
    
    return accessToken;
  } catch (error) {
    console.error("Error fetching access token:", error.response?.data || error.message);
    return null; // Return null if the request fails
  }
};


export const fetchRecruitData = async (accessToken) => {
  try {
    const response = await axios.get("https://career.medha.org.in/api/recruit", {
      headers: {
        Authorization: `${accessToken}`,
      },
    });
    

    return response.data;
  } catch (error) {
    return error.response?.data || { error: "Unknown error occurred" }; // Return the error response
  }
};
;
